// src/components/AppFooter.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * Reusable footer with "Contact" and "Terms of Use" links.
 * Drop it as the last child inside a page that uses `flex flex-col min-h-screen`.
 *
 * Props (optional):
 * - className: extra classes for the outer wrapper
 * - gapClass: spacing between the two links (default: "gap-[1cm]")
 */
export default function AppFooter({
  className = "",
  gapClass = "gap-[1cm]",
}) {
  const navigate = useNavigate();
  const goToContact = () => navigate("/contact");
  const goToTerms = () => navigate("/terms-of-use");
  
  return (
    <footer
      role="contentinfo"
      className={`mt-auto flex ${gapClass} justify-center ${className}`}
    >
      <a
        href="https://www.uevora.pt/unidades/organicas/eartes"
        target="_blank"
        rel="noopener noreferrer"
        className="pt-[1cm] text-sm text-gray-400 text-center hover:text-gray-200 transition"
      >
        School of Arts
      </a>
      <button
        onClick={goToTerms}
        className="pt-[1cm] text-sm text-gray-400 text-center hover:text-gray-200 transition"
      >
        Terms of Use
      </button>
      <button
        onClick={goToContact}
        className="pt-[1cm] text-sm text-gray-400 text-center hover:text-gray-200 transition"
      >
        Contact
      </button>
    </footer>
  );
}

